import { render, staticRenderFns } from "./findPass.vue?vue&type=template&id=40487fac&scoped=true&"
import script from "./findPass.vue?vue&type=script&lang=js&"
export * from "./findPass.vue?vue&type=script&lang=js&"
import style0 from "./findPass.vue?vue&type=style&index=0&id=40487fac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40487fac",
  null
  
)

export default component.exports